/**
 * Which Setups categories each staff role may change. Mirrors
 * server/utils/setupPermissions.js, which is what is enforced; this copy only
 * decides what the Setups page shows.
 */
const ALL_CATEGORIES = ['roles', 'entity_types', 'currencies', 'wealth_sources', 'service_types', 'bank_names', 'departments'];

const EDITABLE_BY_ROLE = {
  super_admin: ALL_CATEGORIES,
  legal: ['entity_types'],
  procurement: ALL_CATEGORIES.filter((c) => !['entity_types', 'roles', 'departments'].includes(c)),
};

export const editableSetupCategories = (role) => EDITABLE_BY_ROLE[role] || [];
